import { DASHBOARD_STORAGE_KEY } from 'utils/constants';

const getDashboardFromLocalstorage = (value) => {
  let data = localStorage.getItem(DASHBOARD_STORAGE_KEY);
  if (!data) return;

  data = JSON.parse(data);
  return value ? data[value] : data;
};

export { getDashboardFromLocalstorage };
